import {
    REQUEST as req,
    RESPONSE as res,
    FAILURE as fail,
    CLEAR as clr,
  } from '../../actions/deployments/delete';
  
  const initialState = {
    response: null,
    isLoading: false,
    error: null,
    success: false
  };
  
  export const reducer = (state = initialState, action) => {
    switch (action.type) {
      case req:
        return {
          ...state,
          isLoading: true,
          error: null,
          success: false
        };
      case res:
        return {
          ...state,
          isLoading: false,
          response: action.payload,
          success: true
        };
      case fail:
        return {
          ...state,
          isLoading: false,
          error: action.payload,
          success: false
        };
      case clr:
        return {
          ...state,
          response: null,
          isLoading: false,
          error: null,
          success: false
        };
      default:
        return state;
    }
  };
